export default __webpack_public_path__ + "static/compareItemImg3-242e636ebac395e7412a4ffd4b9f70f7.webp";